<template>
	<div>
		<Loading v-if="loading" text="Lade Zusagen..."/>
		<div v-else>
			<JonInfo v-if="employments.length === 0">
				<template #message>
					Es sind noch keine Zusagen vorhanden.
				</template>
			</JonInfo>
			<div v-else class="items-list">
				<!--<div class="p-2 font-weight-extra-bold">
					<b-row align-v="center">
						<b-col md="4">Stellenprofil</b-col>
						<b-col md="3">{{ isListTypeCustomer ? 'Person' : 'Firma' }}</b-col>
						<b-col md="3">Kontaktdaten</b-col>
						<b-col md="2">Datum</b-col>
					</b-row>
				</div>-->
				<ListItem
					v-for="item in employments"
					:key="item.id"
					:list-item="item"
					:list-type="type"
				/>
				<Pagination
					v-model="page"
					:page="page"
					:total="meta.total"
					:items-per-page="itemsPerPage"
					class="mb-4"
					@input="loadEmployments"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import Loading from "@/vue/common/Loading";
import GetList from "@/api/employment/GetList";
import Pagination from "@/vue/common/Pagination";
import ListItem from "./ListItem";
import JonInfo from "@/vue/common/JonInfo";

export const LIST_TYPE_CUSTOMER = 'customer';

export default {

	components: {
		Loading,
		Pagination,
		ListItem,
		JonInfo,
	},

	props: {
		type: {
			type: String,
			required: true,
		},
	},

	mounted ()
	{
		this.loadEmployments();
	},

	data ()
	{
		return {
			loading: true,
			employments: null,
			meta: null,
			page: 1,
			itemsPerPage: 10,
		};
	},

	computed: {
		isListTypeCustomer ()
		{
			return this.type === LIST_TYPE_CUSTOMER;
		},
	},

	methods: {
		async loadEmployments ()
		{
			this.loading = true;

			const response = await new GetList()
				.setOffset((this.page - 1) * this.itemsPerPage)
				.setLimit(this.itemsPerPage)
				.call();

			this.employments = response.data;
			this.meta = response.meta;

			this.loading = false;
		}
	}
}
</script>
